<template>
  <button
      type="button"
      class="serp__filters--marked-item-button q-btn q-btn-sm q-btn-light q-me-2 q-mb-2 q-position-relative q-rounded-3 q-shadow-sm"
      v-for="selectedFilter in activeFilter"
      :key="selectedFilter"
      @click.stop.prevent="filtersStore.updateFilter(filterName, selectedFilter)"
  >
    <span class="q-chip__text">
      {{ filtersStore.getFilterLabelByFilterName(filterName) }}: {{ selectedFilter }}
    </span>

    <!-- X tylko wizualny (klik wszędzie działa) -->
    <span class="q-chip__close" aria-hidden="true">
      <svg class="q-chip__icon" viewBox="0 0 24 24">
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </span>
  </button>
</template>


<script setup lang="ts">
import {defineProps} from "vue";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";

defineProps(['activeFilter', 'filterName'])

const filtersStore = useFiltersStore();
</script>
<style>
.serp__filters--marked-item-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px; /* mały luz między fragmentami */
  padding: 6px 30px 6px 10px !important; /* miejsce na X po prawej */
  font-size: 0.80em; /* minimalnie mniejszy font */
  line-height: 1.2;
  text-wrap: nowrap;
  cursor: pointer;
}

.serp__filters--marked-item-button:focus-visible {
  box-shadow: 0 0 0 2px rgba(0, 0, 0, .14);
}

/* X przytulony do treści, ale nie zasłania kliknięcia */
.serp__filters--marked-item-button .q-chip__close {
  position: absolute;
  right: 8px; /* mniejszy odstęp od krawędzi */
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px; /* lżejszy niż wcześniej */
  display: grid;
  place-items: center;
  border-radius: 9999px;
  color: #9aa0a6; /* neutralny */
  pointer-events: none; /* KLUCZ: cały chip klikalny */
}

.serp__filters--marked-item-button .q-chip__icon {
  width: 16px;
  height: 16px;
  display: block;
}

/* estetyka na hover/active – subtelnie */
.serp__filters--marked-item-button:hover {
  filter: brightness(0.98);
}

.serp__filters--marked-item-button:active {
  transform: translateY(0.5px);
}

</style>
